import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import {
  PrescriptionViewModel,
  ReferralPrescriptionType,
} from '../../../models/ViewModels/PrescriptionViewModel'
import {
  LoadingFit,
  PreviewPrescriptionModal,
  RaytebModal,
} from '../../../share/Components'
import React, { useEffect } from 'react'
import {
  Button,
  DatePicker,
  Icon,
  ProvideTypeahead,
  RaytebForm,
  Table,
  TextBox,
  Typeahead,
  TypeaheadText,
} from '../../../share/Elements'
import { useState } from 'react'
import useFetch from '../../../_services/fetch'
import { RaytebRequests } from '../../../_services'
import { useDispatch, useSelector } from 'react-redux'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import { ReferralViewModel } from '../../../models/ViewModels/ReferralViewModel'
import { toast } from 'react-toastify'
import {
  addOrUpdatePrescription,
  updateReferralRow,
  updateShouldPush,
} from '../../../storeManager/Reducers/prescriptionSlice'
type TypeaheadData = {
  show: boolean
  data?: any
}

const Referral = ({
  referral,
  prescriptionId,
  isPreview,
  isReferencable,
}: {
  referral: ReferralPrescriptionType
  prescriptionId: string
  isReferencable?: boolean
  isPreview?: boolean
}) => {
  const dispatch = useDispatch()
  const [data, setData] = useState<ReferralServeViewModel>({})
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const [showList, setshowList] = useState<TypeaheadData>({
    show: false,
    data: {},
  })
  const [showModal, setShowModal] = useState<TypeaheadData>({
    show: false,
    data: {},
  })
  const saveReferral = useFetch<
    ReferralViewModel,
    ReferralInputModel,
    { prescriptionId: string }
  >({
    request: RaytebRequests.Referral_AddOrUpdate_POST({ token: user.token }),
    onSuccess(data) {
      dispatch(updateReferralRow(data.rows))
      dispatch(updateShouldPush(true))
      setShowModal({ show: false })
      setData({ ...data, isEdit: false, name: '' })
      data.messages?.forEach((n) => {
        toast[n.flag](n.message)
      })
    },
  })
  const selectedItem = (item) => {
    setData({ id: item.id, isEdit: false, name: '' })
    setShowModal({ ...showList, show: true })
    setshowList({ show: false })
  }
  const getServe = useFetch<
    Array<ReferralServeViewModel>,
    unknown,
    {
      phrase: string
      count: number
      prescriptionId: string
    }
  >({
    request: RaytebRequests.Referral_GetServe_GET({
      token: user.token,
    }),
  })
  const [showPreview, setShowPreview] = useState<boolean>(false)
  const getPreviewPrescriptionReferral = useFetch<
    PrescriptionViewModel,
    GetPrescriptionReferralInputModel
  >({
    request: RaytebRequests.Prescription_GetPrescriptionReferral_POST({
      token: user.token!,
    }),
    onSuccess(data) {
      setShowPreview(true)
    },
  })
  const deleteReferral = useFetch<
    PrescriptionViewModel,
    unknown,
    {
      id: string
      prescriptionId: string
    }
  >({
    request: RaytebRequests.Referral_Delete_POST({ token: user.token }),
    onSuccess(data) {
      data.shouldPush = true
      dispatch(addOrUpdatePrescription(data))
    },
  })
  const [rowParam, setRowParam] = useState<ReferralInputModel>({})

  // useEffect(() => {
  //   getServe.reFetch(null, {
  //     count: 10,
  //     phrase: '',
  //     prescriptionId: prescriptionId,
  //   })
  // }, [])
  return (
    <div className='relative'>
      <LoadingFit
        isLoading={
          saveReferral.isLoading ||
          deleteReferral.isLoading ||
          getPreviewPrescriptionReferral.isLoading
        }
      />
      {isReferencable ? (
        <div className='px-2 my-2 flex justify-center items-center'>
          <Button
            className='bg-white ring py-1 text-xs font-bold text-primaryLight'
            onClick={() => {
              getPreviewPrescriptionReferral.reFetch({
                prescriptionId: prescriptionId,
              })
            }}
          >
            نمایش نسخه ارجاع شده
          </Button>
        </div>
      ) : (
        ''
      )}
      {showModal.show && !isPreview ? (
        <RaytebForm
          onSubmit={(e) => {
            saveReferral.reFetch(
              {
                description: e.target['description'].value,
                effectiveDate:
                  e.target['effectiveDate'].getAttribute('rayteb-value'),
                id: rowParam.id,
                repeatCount: e.target['repeatCount'].value,
                repeatType: rowParam.repeatType,
                serveId: data.id,
              },
              { prescriptionId: prescriptionId }
            )
          }}
        >
          <div className='w-full p-1 grid grid-cols-2 py-3 gap-x-3 gap-y-6'>
            <DatePicker
              canDeleteDate={true}
              raytebValue={rowParam.effectiveDate}
              value={
                rowParam.effectiveDate
                  ? new Date(rowParam.effectiveDate).toShamsi()
                  : ''
              }
              name='effectiveDate'
              innerText='تاریخ موثر'
              className='w-full !border-0 !border-b !rounded-none
             !focus:border-0 !focus:border-b focus:!ring-0'
            />
            <TypeaheadText<{
              value: number
              title: string
            }>
              selected={(e) => {
                setRowParam({ ...rowParam, repeatType: e.value })
              }}
              listData={[
                { title: 'روز', value: 0 },
                { title: 'هفته', value: 1 },
                { title: 'ماه', value: 2 },
              ]}
              fieldItem='title'
              fieldValue='value'
              isReadOnly={false}
              innerText='نوع تکرار نسخه'
              className='!bg-white'
              classNameList='h-20'
            />
            <TextBox
              innerText='دوره تکرار'
              Type={TextBoxTypeEnum.Number}
              value={rowParam.repeatCount?.toString()}
              name='repeatCount'
              className='w-full border-0 border-b rounded-none
             focus:!border-0 focus:!border-b focus:!ring-0'
            />
            <div className='col-span-2 mt-3'>
              <TextBox
                innerText='توضیحات دارو خدمت ارجاع'
                Type={TextBoxTypeEnum.Text}
                className='!w-full  h-20'
                name='description'
              />
            </div>
          </div>
          <div className='mt-2 flex justify-center items-center px-6 gap-10 w-full'>
            <Button
              onClick={() => setShowModal({ ...showList, show: false })}
              className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              انصراف
            </Button>
            <Button
              type='submit'
              className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
            >
              تایید
            </Button>
          </div>
        </RaytebForm>
      ) : (
        <>
          {!isPreview ? (
            <ProvideTypeahead
              className={`mt-5 col-span-2 ${data.isEdit
                ? 'before:absolute before:z-50 before:bg-white/30 before:w-full before:h-full'
                : ''
                }`}
              showList={showList.show}
              listChildren={
                <ListChildren
                  onClick={(item) => {
                    selectedItem(item)
                  }}
                  pharse={getServe.query?.phrase}
                  listData={getServe.result}
                  isLoading={getServe.isLoading}
                  onHide={() => setshowList({ show: false })}
                />
              }
            >
              <div className='px-1 flex justify-start items-end md:!w-1/2 md:mx-auto'>
                <Typeahead
                  innerText='عنوان'
                  className='!w-full'
                  onFocus={() => {
                    setshowList({ ...showList, show: true })
                  }}
                  onChange={(e) => {
                    if (e.target.value)
                      getServe.reFetch(null, {
                        count: 10,
                        phrase: e.target.value,
                        prescriptionId: prescriptionId,
                      })
                  }}
                  value={data.name}
                  onClick={(e) => e.target.select()}
                ></Typeahead>
              </div>
            </ProvideTypeahead>
          ) : (
            ''
          )}

          <div className='w-full px-2 mt-6'>
            <Table>
              <thead className='text-xs text-primary h-8 border-b border-disable'>
                <tr>
                  <th scope='col' className='pr-2 text-center font-normal '>
                    کد خدمت
                  </th>
                  <th
                    scope='col'
                    className='pt-1 pl-2 text-center font-normal '
                  >
                    تاریخ موثر
                  </th>
                  <th
                    scope='col'
                    className='pt-1 pl-2 text-center font-normal '
                  >
                    توضیحات
                  </th>
                  <th
                    scope='col'
                    className='pt-1 pl-2 text-center font-normal '
                  >
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody className='text-xs'>
                {referral.rows?.map((row, i) => (
                  <tr className='[&>*]:h-10' key={i}>
                    <td className='pr-2 text-center'>{row.serveId}</td>
                    <td className='text-center'>
                      {row.effectiveDate
                        ? new Date(row.effectiveDate).toShamsi()
                        : ''}
                    </td>
                    <td className='text-center'>
                      {row.description?.shortText(40)}
                    </td>
                    <td className='grid grid-cols-1 justify-items-center p-1 gap-1'>
                      {!row.isDeleted ? (
                        <>
                          <Icon
                            icon='rayteb-delete'
                            className='text-[17px] text-danger'
                            onClick={() => {
                              deleteReferral.reFetch(null, {
                                prescriptionId: prescriptionId,
                                id: row.id!,
                              })
                            }}
                            disabled={isPreview}
                          />
                          {/* <Icon
                          icon='rayteb-edit'
                          className='text-[17px] text-warn'
                          onClick={() => {
                            setData({
                              name: row.title!,
                              id: row.id!,
                              isEdit: true,
                            })
                            setRowParam({
                              description: row.description,
                              effectiveDate: row.effectiveDate,
                              id: row.id,
                              serveId: row.serveId!,
                            })
                            setShowModal({ show: true })
                          }}
                        /> */}
                        </>
                      ) : (
                        ''
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </>
      )}
      <PreviewPrescriptionModal
        isOpen={showPreview}
        prescription={getPreviewPrescriptionReferral.result!}
        hideModal={() => setShowPreview(false)}
      />
    </div>
  )
}

type ListChildrenType = {
  listData?: Array<ReferralServeViewModel>
  className?: string | undefined
  isLoading: boolean
  onHide?: () => void
  pharse?: string
  onClick?: (param: ReferralServeViewModel) => void
}
const ListChildren: React.FC<ListChildrenType> = ({
  className,
  listData,
  isLoading,
  pharse,
  onClick,
  onHide,
}) => {
  return (
    <>
      <div>
        <LoadingFit isLoading={isLoading} />
        <div className='border-b border-disable bg-white py-2 px-1 flex items-center'>
          <Icon
            icon='rayteb-android-close'
            className='text-xl'
            onClick={() => onHide?.()}
          />

          {!pharse || pharse?.length === 0 ? (
            <p className='text-xs  text-primary mr-2 font-bold'>
              برای جستجو حداقل یک عبارت وارد کنید
            </p>
          ) : (
            <p className='text-xs mr-2 font-bold text-warn '>
              برای تجویز بر روی یکی از موارد کلیک کنید
            </p>
          )}
        </div>
        <div className='h-64 overflow-y-auto'>
          <ul
            className={`flex justify-center flex-col  
           items-center p-2 shadow-sm  ${className ?? ''}`}
          >
            {listData?.map((n, i) => (
              <li
                key={i}
                className='flex justify-start items-center   py-1  w-full hover:bg-primaryDefault hover:cursor-pointer'
                onClick={() => onClick?.(n)}
              >
                <p className='text-xs font-bold text-end text-primaryLight'>
                  {n.name}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  )
}
export default React.memo(Referral)
